import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Navigation/Header';
import Footer from './components/Navigation/Footer';
import Home from './pages/Home';
import Archives from './pages/Archives';
import WeeklySummaryDetail from './pages/WeeklySummaryDetail';
import ArticleDetail from './pages/ArticleDetail';
import AISolutions from './pages/AISolutions';
import Admin from './pages/Admin';
import DailySummaryDetail from './pages/DailySummaryDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/archives" element={<Archives />} />
            <Route path="/archives/week/:weekId" element={<WeeklySummaryDetail />} />
            <Route path="/article/:slug" element={<ArticleDetail />} />
            <Route path="/daily/:dailyParam" element={<DailySummaryDetail />} />
            <Route path="/ai-solutions" element={<AISolutions />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
